<template>
  <section class="single-slider-selector">
    <section class="labels">
      <span class="zero">0%</span
      ><span class="ten">10%</span
      ><span class="twenty">20%</span
      ><span class="thirty">30%</span
      ><span class="fourty">40%</span
      ><span class="fifty">50%</span
      ><span class="sixty">60%</span
      ><span class="seventy">70%</span
      ><span class="eighty">80%</span
      ><span class="ninty">90%</span
      ><span class="one-hundred">100%</span>
    </section>

    <input
      type="range"
      min="0"
      max="100"
      step="1"
      list="percent-of-hands"
      v-bind:value="percentOfHandsInRangeNumberForDisplay"
      v-bind:disabled="disabled"
      v-on:input="setRangeToMatchSingleSlider($event.target.value)"
    />

    <datalist id="percent-of-hands">
      <option>0</option>
      <option>10</option>
      <option>20</option>
      <option>30</option>
      <option>40</option>
      <option>50</option>
      <option>60</option>
      <option>70</option>
      <option>80</option>
      <option>90</option>
      <option>100</option>
    </datalist>
  </section>
</template>

<script>
export default {
  name: 'single-slider-selector',
  props: ['percentOfHandsInRangeNumberForDisplay', 'disabled'],
  methods: {
    setRangeToMatchSingleSlider: function (targetPercentage) {
      this.$emit('setRangeToMatchDoubleSlider', {
        topPercentile: targetPercentage,
        bottomPercentile: 0,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "src/assets/mixins";

  .single-slider-selector {
    width: 100%;
  }

  .labels {
    position: relative;

    span {
      font-size: 8px;
      @include noselect();
      width: 9.6%;
      display: inline-block;
    }

    .one-hundred {
      position: absolute;
      right: -10px;
      top: 3.5px;
    }
  }

  input[type="range"]:active {
    cursor: ew-resize;
  }

  @media (max-width: 472px) {
    input[type=range] {
      -webkit-appearance: none;
      margin: 18px 0;
      width: 100%;
    }
    input[type=range]:focus {
      outline: none;
    }
    input[type=range]::-webkit-slider-runnable-track {
      width: 100%;
      height: 8.4px;
      cursor: pointer;
      animate: 0.2s;
      background: lightgray;
      border-radius: 1.3px;
    }
    input[type=range]::-webkit-slider-thumb {
      border: 1px solid lightgray;
      height: 36px;
      width: 16px;
      border-radius: 3px;
      background: #ffffff;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -14px;
    }
    input[type=range]::-moz-range-track {
      width: 100%;
      height: 8.4px;
      cursor: pointer;
      animate: 0.2s;
      background: lightgray;
      border-radius: 1.3px;
    }
    input[type=range]::-moz-range-thumb {
      border: 1px solid lightgray;
      height: 36px;
      width: 16px;
      border-radius: 3px;
      background: #ffffff;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/slider-selector/single-slider-selector.vue